/**
 * Selection mode.
 *   - `single` (default): picking a card replaces the selection. The
 *     dialog typically commits-and-closes on selection (configurable
 *     via `commitOnSelect`)
 *   - `multiple`: cards toggle in/out of the selection set; commit
 *     happens on the explicit confirm button
 */
export const CARD_PICKER_SELECTION_SINGLE = 'single';
export const CARD_PICKER_SELECTION_MULTIPLE = 'multiple';

export type CardPickerSelectionMode =
  | typeof CARD_PICKER_SELECTION_SINGLE
  | typeof CARD_PICKER_SELECTION_MULTIPLE;

/**
 * Grid density tokens — controls the minimum card width and the gap
 * between cards. The grid itself uses `auto-fill` so the count of
 * columns is responsive to the modal width.
 *   - `compact`     176px min, 8px gap  (ideal for icon-led picks)
 *   - `regular`     220px min, 12px gap (default)
 *   - `comfortable` 280px min, 16px gap (longer descriptions, hero icons)
 */
export const CARD_PICKER_DENSITY_COMPACT = 'compact';
export const CARD_PICKER_DENSITY_REGULAR = 'regular';
export const CARD_PICKER_DENSITY_COMFORTABLE = 'comfortable';

export type CardPickerDensity =
  | typeof CARD_PICKER_DENSITY_COMPACT
  | typeof CARD_PICKER_DENSITY_REGULAR
  | typeof CARD_PICKER_DENSITY_COMFORTABLE;

export const CARD_PICKER_DENSITY_TOKENS: Record<
  CardPickerDensity,
  { minCardWidth: string; gap: string; cardPadY: string; cardPadX: string }
> = {
  [CARD_PICKER_DENSITY_COMPACT]: {
    minCardWidth: '176px',
    gap: '8px',
    cardPadY: '12px',
    cardPadX: '12px',
  },
  [CARD_PICKER_DENSITY_REGULAR]: {
    minCardWidth: '220px',
    gap: '12px',
    cardPadY: '14px',
    cardPadX: '14px',
  },
  [CARD_PICKER_DENSITY_COMFORTABLE]: {
    minCardWidth: '280px',
    gap: '16px',
    cardPadY: '18px',
    cardPadX: '18px',
  },
};
